<template>
  <Content>
    <div class="modern-table-card p-4">
      <div
        class="table-header d-flex align-items-center justify-content-between mb-4"
      >
        <h3>{{ currentLang.title }}</h3>
        <button
          class="btn btn-primary create-btn"
          @click="openChapterModal('create', null)"
        >
          <i class="bi bi-plus-lg"></i> {{ currentLang.btnAddChapters }}
        </button>
      </div>

      <div v-if="loading" class="text-center py-5">
        {{ currentLang.loading }}
      </div>

      <div class="tree-container">
        <ChapterItem
          v-for="chapter in chapters"
          :key="chapter.id"
          :chapter="chapter"
          @refresh="fetchData"
          @edit-chapter="openChapterModal('edit', $event)"
          @add-media="openMediaModal('create', null, $event)"
          @edit-media="openMediaModal('edit', $event.media, $event.chapterId)"
        />
      </div>
    </div>

    <!-- مدال سرفصل -->
    <ChapterModal
      v-model="isChapterModalOpen"
      :mode="chapterMode"
      :target-item="selectedChapter"
      :product-id="productId"
      @refresh="fetchData"
    />

    <!-- مدال مدیا -->
    <MediaModal
      v-model="isMediaModalOpen"
      :mode="mediaMode"
      :target-media="selectedMedia"
      :chapter-id="selectedChapterId"
      @refresh="fetchData"
    />
  </Content>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import Content from "@/components/AdminContent.vue";

import { useRoute } from "vue-router";
import api from "@/plugins/axios";
import ChapterItem from "@/components/ChapterItem.vue";
import ChapterModal from "@/components/ChapterModal.vue";
import MediaModal from "@/components/MediaModal.vue";
import { lang } from "@/plugins/lang";

import enText from "@/locales/en/chapters";
import faText from "@/locales/fa/chapters";
import { showLoading, hideLoading } from "@/stores/loading";

const translations = {
  en: enText,
  fa: faText,
};
const currentLang = computed(() => translations[lang.value]);

const route = useRoute();
const productId = route.params.id;
const chapters = ref([]);
const loading = ref(false);

// State برای مدال‌ها
const isChapterModalOpen = ref(false);
const chapterMode = ref("create");
const selectedChapter = ref(null);

const isMediaModalOpen = ref(false);
const mediaMode = ref("create");
const selectedMedia = ref(null);
const selectedChapterId = ref(null);

const fetchData = async () => {
  loading.value = true;
  showLoading();

  try {
    const { data } = await api.get(`/admin/products/${productId}/chapters`);
    chapters.value = data.data.chapters;
  } finally {
    loading.value = false;
    hideLoading();
  }
};

const openChapterModal = (mode, item) => {
  chapterMode.value = mode;
  selectedChapter.value = item;
  isChapterModalOpen.value = true;
};

const openMediaModal = (mode, media, chapterId) => {
  mediaMode.value = mode;
  selectedMedia.value = media;
  selectedChapterId.value = chapterId;
  isMediaModalOpen.value = true;
};

onMounted(fetchData);
</script>

<style scoped>
.tree-container {
  background: #fff;
  border-radius: 12px;
  padding: 10px;
}

.create-btn {
  border: none;
  border-radius: 10px;
  padding: 10px 18px;
  background: #ffffff;
  color: #334155;
  font-weight: 600;
  transition: 0.2s ease;

  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.08);
}

.create-btn:hover {
  background: #f8fafc;
  color: #0f172a;

  transform: translateY(-1px);

  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.12);
}
</style>

